export default ({
  pageState: { editorBlocks },
  data: { blockId, data, editor, updatedAt }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: JSON.parse(JSON.stringify(data)),
        editor,
        isEdited: true,
        updatedAt
      }
    },
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  }; 
};
